import { IAPICheckoutGridModel, Item } from "../interfaces";
import { PaymentModuleUtility } from "../utils/PaymentModuleUtility";

export class CheckoutGridModel {
  id: string;
  name: string;
  link: string;
  items: Item[];
  isActive: boolean;
  lastPurchase?: Date;
  purchaseBaseURL: string;
  totalAmount: number;
  totalPurchases: number;
  constructor(data?: Partial<CheckoutGridModel>) {
    this.name = data?.name || "";
    this.lastPurchase = data?.lastPurchase;
    this.id = data?.id || "";
    this.isActive = data?.isActive || false;
    this.items = data?.items || [];
    this.totalAmount = data?.totalAmount || 0;
    this.totalPurchases = data?.totalPurchases || 0;
    this.purchaseBaseURL = PaymentModuleUtility.removeLastBackslash(
      data?.purchaseBaseURL
    );
    this.link = "";
    if (this.purchaseBaseURL) {
      this.link = this.purchaseBaseURL + "/app/purchase/checkout/" + this.id;
    }
  }

  static deserialize(data: IAPICheckoutGridModel): CheckoutGridModel {
    return new CheckoutGridModel({
      id: data.id,
      name: data.name,
      items: data.items,
      lastPurchase: data.lastPurchaseDate
        ? new Date(data.lastPurchaseDate)
        : undefined,
      isActive: data.isActive,
      purchaseBaseURL: data.purchaseBaseURL,
      totalAmount: data.totalAmount,
      totalPurchases: data.totalPurchases,
    });
  }
}
